import { apiClient } from '@/services/client/ApiClient.js';

export default {
  getAreaById(areaId) {
    return this.getAll().then((response) => {
      if (areaId) {
        return response.data.find((item) => {
          return item.id === areaId;
        });
      }
    });
  },
  getAll() {
    return apiClient.get('/areas', { useCache: true });
  }
};
